import { SpinResponseData } from "@lib/titan2-slingo/dist/api/data/SpinResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
/**
 * ExtendedSpinResponseData.ts
 */
export class ExtendedSpinResponseData extends SpinResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
}
//# sourceMappingURL=ExtendedSpinResponseData.js.map